window.addEventListener('hashchange', function () {
    // Remove decimal if zero
    // document.querySelectorAll('.formula-replace').forEach(element => {
    //     element.innerHTML = element.innerHTML.replace(/\.00/g, '');
    // });
    // setTimeout(() => {l
    //     document.querySelectorAll('.formula-replace').forEach(element => {
    //         element.innerHTML = element.innerHTML.replace(/\.00/g, '');
    //     });
    // }, 100);
    // setTimeout(() => {
    //     document.querySelectorAll('.formula-replace').forEach(element => {
    //         element.innerHTML = element.innerHTML.replace(/\.00/g, '');
    //     });
    // }, 1000);
    // setTimeout(() => {
    //     document.querySelectorAll('.formula-replace').forEach(element => {
    //         element.innerHTML = element.innerHTML.replace(/\.00/g, '');
    //     });
    // }, 2000);
    
    setTimeout(() => {
        const score = document.getElementById("text-block-id-fc763d29").innerText;
        document.querySelector('#input-224e8ff9-container input').value = score;
    }, 2000);
    
    const hash = window.location.href.split('#')[1];
    if(hash === 'loader-w-ar') {
        setTimeout(() => {
            const score = document.getElementById("text-block-id-061772a1").innerText;
            if(score === "Error") {
                alert("Something went wrong");
                return;
            }
            if(+score >= 60) {
                document.getElementById("button-72bab899").click();
            } else if (+score < 30) {
                document.getElementById("button-b3302112").click();
            } else {
                document.getElementById("button-430eac37").click();
            }
            
        }, 2000);
    }
});

document.addEventListener("DOMContentLoaded", function () {
// Define the list of countries with their flags and phone formats
    const countries = [
  {
    name: "Afghanistan",
    code: "+93",
    flag: "🇦🇫",
    mask: "00-000-0000",
    placeholder: "20-123-4567"
  },
  {
    name: "Albania",
    code: "+355",
    flag: "🇦🇱",
    mask: "000-000-0000",
    placeholder: "066-123-4567"
  },
  {
    name: "Algeria",
    code: "+213",
    flag: "🇩🇿",
    mask: "00-000-00-00-00",
    placeholder: "0550-00-00-00"
  },
  {
    name: "Andorra",
    code: "+376",
    flag: "🇦🇩",
    mask: "000-000",
    placeholder: "312-345"
  },
  {
    name: "Angola",
    code: "+244",
    flag: "🇦🇴",
    mask: "000-000-000",
    placeholder: "222-123-456"
  },
  {
    name: "Antigua and Barbuda",
    code: "+1",
    flag: "🇦🇬",
    mask: "(000) 000-0000",
    placeholder: "(268) 464-1234"
  },
  {
    name: "Argentina",
    code: "+54",
    flag: "🇦🇷",
    mask: "000-000-0000",
    placeholder: "011-1234-5678"
  },
  {
    name: "Armenia",
    code: "+374",
    flag: "🇦🇲",
    mask: "000-000-000",
    placeholder: "077-123-456"
  },
  {
    name: "Australia",
    code: "+61",
    flag: "🇦🇺",
    mask: "0000 000 000",
    placeholder: "0412 345 678"
  },
  {
    name: "Austria",
    code: "+43",
    flag: "🇦🇹",
    mask: "0000 000000",
    placeholder: "0664 123456"
  },
  {
    name: "Azerbaijan",
    code: "+994",
    flag: "🇦🇿",
    mask: "00-000-000-00-00",
    placeholder: "050-123-45-67"
  },
  {
    name: "Bahamas",
    code: "+1",
    flag: "🇧🇸",
    mask: "(000) 000-0000",
    placeholder: "(242) 359-1234"
  },
  {
    name: "Bahrain",
    code: "+973",
    flag: "🇧🇭",
    mask: "0000 0000",
    placeholder: "3600 1234"
  },
  {
    name: "Bangladesh",
    code: "+880",
    flag: "🇧🇩",
    mask: "00000-000000",
    placeholder: "01812-345678"
  },
  {
    name: "Barbados",
    code: "+1",
    flag: "🇧🇧",
    mask: "(000) 000-0000",
    placeholder: "(246) 250-1234"
  },
  {
    name: "Belarus",
    code: "+375",
    flag: "🇧🇾",
    mask: "00-000-000-00-00",
    placeholder: "8-017-123-45-67"
  },
  {
    name: "Belgium",
    code: "+32",
    flag: "🇧🇪",
    mask: "0000 00 00 00",
    placeholder: "0471 12 34 56"
  },
  {
    name: "Belize",
    code: "+501",
    flag: "🇧🇿",
    mask: "000-0000",
    placeholder: "601-1234"
  },
  {
    name: "Benin",
    code: "+229",
    flag: "🇧🇯",
    mask: "00-00-00-00-00",
    placeholder: "90-01-23-45"
  },
  {
    name: "Bhutan",
    code: "+975",
    flag: "🇧🇹",
    mask: "00-00-00-00",
    placeholder: "17-12-34-56"
  },
  {
    name: "Bolivia",
    code: "+591",
    flag: "🇧🇴",
    mask: "000-000-000",
    placeholder: "7123-4567"
  },
  {
    name: "Bosnia and Herzegovina",
    code: "+387",
    flag: "🇧🇦",
    mask: "000-000-000",
    placeholder: "061-123-456"
  },
  {
    name: "Botswana",
    code: "+267",
    flag: "🇧🇼",
    mask: "00 00 0000",
    placeholder: "71 123 456"
  },
  {
    name: "Brazil",
    code: "+55",
    flag: "🇧🇷",
    mask: "(00) 00000-0000",
    placeholder: "(11) 91234-5678"
  },
  {
    name: "Brunei",
    code: "+673",
    flag: "🇧🇳",
    mask: "000-0000",
    placeholder: "712-3456"
  },
  {
    name: "Bulgaria",
    code: "+359",
    flag: "🇧🇬",
    mask: "000 000 000",
    placeholder: "0888 123 456"
  },
  {
    name: "Burkina Faso",
    code: "+226",
    flag: "🇧🇫",
    mask: "00-00-00-00",
    placeholder: "70-12-34-56"
  },
  {
    name: "Burundi",
    code: "+257",
    flag: "🇧🇮",
    mask: "00 00 00 00",
    placeholder: "79 12 34 56"
  },
  {
    name: "Cambodia",
    code: "+855",
    flag: "🇰🇭",
    mask: "000 000 000",
    placeholder: "091 234 567"
  },
  {
    name: "Cameroon",
    code: "+237",
    flag: "🇨🇲",
    mask: "00-00-00-00",
    placeholder: "6-71-23-45-67"
  },
  {
    name: "Canada",
    code: "+1",
    flag: "🇨🇦",
    mask: "000-000-0000",
    placeholder: "555-555-1234"
  },
  {
    name: "Cape Verde",
    code: "+238",
    flag: "🇨🇻",
    mask: "000-0000",
    placeholder: "991-1234"
  },
  {
    name: "Central African Republic",
    code: "+236",
    flag: "🇨🇫",
    mask: "00 00 00 00",
    placeholder: "70 01 23 45"
  },
  {
    name: "Chad",
    code: "+235",
    flag: "🇹🇩",
    mask: "00-00-00-00",
    placeholder: "63-01-23-45"
  },
  {
    name: "Chile",
    code: "+56",
    flag: "🇨🇱",
    mask: "(0) 00 0000 0000",
    placeholder: "(2) 2123 4567"
  },
  {
    name: "China",
    code: "+86",
    flag: "🇨🇳",
    mask: "000 0000 0000",
    placeholder: "131 2345 6789"
  },
  {
    name: "Colombia",
    code: "+57",
    flag: "🇨🇴",
    mask: "000 000 0000",
    placeholder: "321 1234567"
  },
  {
    name: "Comoros",
    code: "+269",
    flag: "🇰🇲",
    mask: "00-00-00-00",
    placeholder: "321-23-45"
  },
  {
    name: "Congo, Republic of the (Brazzaville)",
    code: "+242",
    flag: "🇨🇬",
    mask: "00-000-00-00-00",
    placeholder: "06-123-45-67"
  },
  {
    name: "Congo, Democratic Republic of the (Kinshasa)",
    code: "+243",
    flag: "🇨🇩",
    mask: "00-000-0000",
    placeholder: "0991-123-456"
  },
  {
    name: "Costa Rica",
    code: "+506",
    flag: "🇨🇷",
    mask: "0000-0000",
    placeholder: "8312-3456"
  },
  {
    name: "Croatia",
    code: "+385",
    flag: "🇭🇷",
    mask: "000 000 0000",
    placeholder: "091 234 5678"
  },
  {
    name: "Cuba",
    code: "+53",
    flag: "🇨🇺",
    mask: "00-000-0000",
    placeholder: "05-123-4567"
  },
  {
    name: "Cyprus",
    code: "+357",
    flag: "🇨🇾",
    mask: "0000-0000",
    placeholder: "99-123456"
  },
  {
    name: "Czech Republic",
    code: "+420",
    flag: "🇨🇿",
    mask: "000 000 000",
    placeholder: "601 123 456"
  },
  {
    name: "Denmark",
    code: "+45",
    flag: "🇩🇰",
    mask: "00 00 00 00",
    placeholder: "12 34 56 78"
  },
  {
    name: "Djibouti",
    code: "+253",
    flag: "🇩🇯",
    mask: "00-00-00-00",
    placeholder: "77-83-45-67"
  },
  {
    name: "Dominica",
    code: "+1",
    flag: "🇩🇲",
    mask: "(000) 000-0000",
    placeholder: "(767) 225-1234"
  },
  {
    name: "Dominican Republic",
    code: "+1",
    flag: "🇩🇴",
    mask: "(000) 000-0000",
    placeholder: "(809) 234-5678"
  },
  {
    name: "East Timor (Timor-Leste)",
    code: "+670",
    flag: "🇹🇱",
    mask: "0000-0000",
    placeholder: "7723-4567"
  },
  {
    name: "Ecuador",
    code: "+593",
    flag: "🇪🇨",
    mask: "000-000-0000",
    placeholder: "099 123 4567"
  },
  {
    name: "Egypt",
    code: "+20",
    flag: "🇪🇬",
    mask: "0100 000 0000",
    placeholder: "0100 123 4567"
  },
  {
    name: "El Salvador",
    code: "+503",
    flag: "🇸🇻",
    mask: "0000-0000",
    placeholder: "7012-3456"
  },
  {
    name: "Equatorial Guinea",
    code: "+240",
    flag: "🇬🇶",
    mask: "000-000-000",
    placeholder: "222-123-456"
  },
  {
    name: "Eritrea",
    code: "+291",
    flag: "🇪🇷",
    mask: "0-00-00-00",
    placeholder: "07-123-456"
  },
  {
    name: "Estonia",
    code: "+372",
    flag: "🇪🇪",
    mask: "0000 0000",
    placeholder: "5123 4567"
  },
  {
    name: "Ethiopia",
    code: "+251",
    flag: "🇪🇹",
    mask: "00 000 0000",
    placeholder: "091 123 4567"
  },
  {
    name: "Fiji",
    code: "+679",
    flag: "🇫🇯",
    mask: "000 0000",
    placeholder: "999 1234"
  },
  {
    name: "Finland",
    code: "+358",
    flag: "🇫🇮",
    mask: "00 000 0000",
    placeholder: "040 123 4567"
  },
  {
    name: "France",
    code: "+33",
    flag: "🇫🇷",
    mask: "00 00 00 00 00",
    placeholder: "06 12 34 56 78"
  },
  {
    name: "Gabon",
    code: "+241",
    flag: "🇬🇦",
    mask: "00-00-00-00",
    placeholder: "06-12-34-56"
  },
  {
    name: "Gambia",
    code: "+220",
    flag: "🇬🇲",
    mask: "000-0000",
    placeholder: "301-2345"
  },
  {
    name: "Georgia",
    code: "+995",
    flag: "🇬🇪",
    mask: "000 00 00 00",
    placeholder: "555 12 34 56"
  },
  {
    name: "Germany",
    code: "+49",
    flag: "🇩🇪",
    mask: "0000 0000000",
    placeholder: "01512 3456789"
  },
  {
    name: "Ghana",
    code: "+233",
    flag: "🇬🇭",
    mask: "000 000 0000",
    placeholder: "020 123 4567"
  },
  {
    name: "Greece",
    code: "+30",
    flag: "🇬🇷",
    mask: "000 000 0000",
    placeholder: "690 123 4567"
  },
  {
    name: "Grenada",
    code: "+1",
    flag: "🇬🇩",
    mask: "(000) 000-0000",
    placeholder: "(473) 359-1234"
  },
  {
    name: "Guatemala",
    code: "+502",
    flag: "🇬🇹",
    mask: "0000-0000",
    placeholder: "4123-4567"
  },
  {
    name: "Guinea",
    code: "+224",
    flag: "🇬🇳",
    mask: "00 00 00 00 00",
    placeholder: "620 12 34 56"
  },
  {
    name: "Guinea-Bissau",
    code: "+245",
    flag: "🇬🇼",
    mask: "00-00-00-00",
    placeholder: "955-1234"
  },
  {
    name: "Guyana",
    code: "+592",
    flag: "🇬🇾",
    mask: "000-0000",
    placeholder: "609-1234"
  },
  {
    name: "Haiti",
    code: "+509",
    flag: "🇭🇹",
    mask: "00-00-0000",
    placeholder: "34-12-3456"
  },
  {
    name: "Honduras",
    code: "+504",
    flag: "🇭🇳",
    mask: "0000-0000",
    placeholder: "9123-4567"
  },
  {
    name: "Hungary",
    code: "+36",
    flag: "🇭🇺",
    mask: "(00) 000 0000",
    placeholder: "(20) 123 4567"
  },
  {
    name: "Iceland",
    code: "+354",
    flag: "🇮🇸",
    mask: "000 0000",
    placeholder: "611 2345"
  },
  {
    name: "India",
    code: "+91",
    flag: "🇮🇳",
    mask: "0000-000000",
    placeholder: "0123-456789"
  },
  {
    name: "Indonesia",
    code: "+62",
    flag: "🇮🇩",
    mask: "0000-0000",
    placeholder: "0812-345-678"
  },
  {
    name: "Iran",
    code: "+98",
    flag: "🇮🇷",
    mask: "0000 000 0000",
    placeholder: "0912 345 6789"
  },
  {
    name: "Iraq",
    code: "+964",
    flag: "🇮🇶",
    mask: "000 000 0000",
    placeholder: "0790 123 4567"
  },
  {
    name: "Ireland",
    code: "+353",
    flag: "🇮🇪",
    mask: "00 000 0000",
    placeholder: "085 123 4567"
  },
  {
    name: "Italy",
    code: "+39",
    flag: "🇮🇹",
    mask: "000 000 0000",
    placeholder: "312 345 6789"
  },
  {
    name: "Jamaica",
    code: "+1",
    flag: "🇯🇲",
    mask: "(000) 000-0000",
    placeholder: "(876) 512-3456"
  },
  {
    name: "Japan",
    code: "+81",
    flag: "🇯🇵",
    mask: "000-000-0000",
    placeholder: "090-1234-5678"
  },
  {
    name: "Jordan",
    code: "+962",
    flag: "🇯🇴",
    mask: "00 000 0000",
    placeholder: "07 9012 3456"
  },
  {
    name: "Kazakhstan",
    code: "+7",
    flag: "🇰🇿",
    mask: "000 000 0000",
    placeholder: "8 (701) 234 5678"
  },
  {
    name: "Kenya",
    code: "+254",
    flag: "🇰🇪",
    mask: "0000-000000",
    placeholder: "0712-345678"
  },
  {
    name: "Kiribati",
    code: "+686",
    flag: "🇰🇮",
    mask: "00000",
    placeholder: "31234"
  },
  {
    name: "Kuwait",
    code: "+965",
    flag: "🇰🇼",
    mask: "0000 0000",
    placeholder: "5000 1234"
  },
  {
    name: "Kyrgyzstan",
    code: "+996",
    flag: "🇰🇬",
    mask: "0 (000) 000-000",
    placeholder: "0 (312) 123-456"
  },
  {
    name: "Laos",
    code: "+856",
    flag: "🇱🇦",
    mask: "00 000 000",
    placeholder: "020 123 456"
  },
  {
    name: "Latvia",
    code: "+371",
    flag: "🇱🇻",
    mask: "00 000 000",
    placeholder: "20 123 456"
  },
  {
    name: "Lebanon",
    code: "+961",
    flag: "🇱🇧",
    mask: "00 000 000",
    placeholder: "03 123 456"
  },
  {
    name: "Lesotho",
    code: "+266",
    flag: "🇱🇸",
    mask: "0000 0000",
    placeholder: "5012 3456"
  },
  {
    name: "Liberia",
    code: "+231",
    flag: "🇱🇷",
    mask: "0000 0000",
    placeholder: "077 123 4567"
  },
  {
    name: "Libya",
    code: "+218",
    flag: "🇱🇾",
    mask: "000-000-0000",
    placeholder: "091-234-5678"
  },
  {
    name: "Liechtenstein",
    code: "+423",
    flag: "🇱🇮",
    mask: "000 000 0000",
    placeholder: "661 234 567"
  },
  {
    name: "Lithuania",
    code: "+370",
    flag: "🇱🇹",
    mask: "(00) 000 000",
    placeholder: "(8-612) 12 345"
  },
  {
    name: "Luxembourg",
    code: "+352",
    flag: "🇱🇺",
    mask: "000 000 000",
    placeholder: "621 123 456"
  },
  {
    name: "Macao",
    code: "+853",
    flag: "🇲🇴",
    mask: "0000 0000",
    placeholder: "6612 3456"
  },
  {
    name: "Madagascar",
    code: "+261",
    flag: "🇲🇬",
    mask: "00 00 000 00",
    placeholder: "032 12 345 67"
  },
  {
    name: "Malawi",
    code: "+265",
    flag: "🇲🇼",
    mask: "00 00 000 0000",
    placeholder: "0999 12 34 56"
  },
  {
    name: "Malaysia",
    code: "+60",
    flag: "🇲🇾",
    mask: "00-0000 0000",
    placeholder: "012-345 6789"
  },
  {
    name: "Maldives",
    code: "+960",
    flag: "🇲🇻",
    mask: "000-0000",
    placeholder: "771-2345"
  },
  {
    name: "Mali",
    code: "+223",
    flag: "🇲🇱",
    mask: "00 00 00 00",
    placeholder: "76 12 34 56"
  },
  {
    name: "Malta",
    code: "+356",
    flag: "🇲🇹",
    mask: "00 00 00 00",
    placeholder: "9912 3456"
  },
  {
    name: "Marshall Islands",
    code: "+692",
    flag: "🇲🇭",
    mask: "000-0000",
    placeholder: "235-6789"
  },
  {
    name: "Martinique",
    code: "+596",
    flag: "🇲🇶",
    mask: "0000 00 00 00",
    placeholder: "0696 12 34 56"
  },
  {
    name: "Mauritania",
    code: "+222",
    flag: "🇲🇷",
    mask: "00 00 00 00",
    placeholder: "22 12 34 56"
  },
  {
    name: "Mauritius",
    code: "+230",
    flag: "🇲🇺",
    mask: "000 0000",
    placeholder: "5251 2345"
  },
  {
    name: "Mayotte",
    code: "+262",
    flag: "🇾🇹",
    mask: "0000 00 00 00",
    placeholder: "0639 12 34 56"
  },
  {
    name: "Mexico",
    code: "+52",
    flag: "🇲🇽",
    mask: "000 000 0000",
    placeholder: "55 1234 5678"
  },
  {
    name: "Micronesia",
    code: "+691",
    flag: "🇫🇲",
    mask: "000-0000",
    placeholder: "123-4567"
  },
  {
    name: "Moldova",
    code: "+373",
    flag: "🇲🇩",
    mask: "0000-00000",
    placeholder: "022-12345"
  },
  {
    name: "Monaco",
    code: "+377",
    flag: "🇲🇨",
    mask: "00-00-00-00-00",
    placeholder: "01-23-45-67-89"
  },
  {
    name: "Mongolia",
    code: "+976",
    flag: "🇲🇳",
    mask: "0000-0000",
    placeholder: "0112-3456"
  },
  {
    name: "Montenegro",
    code: "+382",
    flag: "🇲🇪",
    mask: "000-000-000",
    placeholder: "067-123-456"
  },
  {
    name: "Montserrat",
    code: "+1",
    flag: "🇲🇸",
    mask: "(000) 000-0000",
    placeholder: "(664) 492-3456"
  },
  {
    name: "Morocco",
    code: "+212",
    flag: "🇲🇦",
    mask: "00-00-00-00-00",
    placeholder: "05-22-33-44-55"
  },
  {
    name: "Mozambique",
    code: "+258",
    flag: "🇲🇿",
    mask: "000-000-000",
    placeholder: "821-234-567"
  },
  {
    name: "Myanmar",
    code: "+95",
    flag: "🇲🇲",
    mask: "000-000-000",
    placeholder: "01-234-567"
  },
  {
    name: "Namibia",
    code: "+264",
    flag: "🇳🇦",
    mask: "000-000-0000",
    placeholder: "061-123-4567"
  },
  {
    name: "Nauru",
    code: "+674",
    flag: "🇳🇷",
    mask: "000-0000",
    placeholder: "555-1234"
  },
  {
    name: "Nepal",
    code: "+977",
    flag: "🇳🇵",
    mask: "0000-000000",
    placeholder: "01-2345678"
  },
  {
    name: "Netherlands",
    code: "+31",
    flag: "🇳🇱",
    mask: "00-000-0000",
    placeholder: "010-1234567"
  },
  {
    name: "New Caledonia",
    code: "+687",
    flag: "🇳🇨",
    mask: "00-00-00",
    placeholder: "25-12-34"
  },
  {
    name: "New Zealand",
    code: "+64",
    flag: "🇳🇿",
    mask: "00-000-000",
    placeholder: "021-234-5678"
  },
  {
    name: "Nicaragua",
    code: "+505",
    flag: "🇳🇮",
    mask: "0000-0000",
    placeholder: "2222-1234"
  },
  {
    name: "Niger",
    code: "+227",
    flag: "🇳🇪",
    mask: "00 00 00 00",
    placeholder: "99 99 99 99"
  },
  {
    name: "Nigeria",
    code: "+234",
    flag: "🇳🇬",
    mask: "0000 000 0000",
    placeholder: "0801 234 5678"
  },
  {
    name: "Niue",
    code: "+683",
    flag: "🇳🇺",
    mask: "0000",
    placeholder: "1234"
  },
  {
    name: "Norfolk Island",
    code: "+672",
    flag: "🇳🇫",
    mask: "00 000 000",
    placeholder: "3 22345"
  },
  {
    name: "North Korea",
    code: "+850",
    flag: "🇰🇵",
    mask: "000 000 0000",
    placeholder: "019 123 4567"
  },
  {
    name: "North Macedonia",
    code: "+389",
    flag: "🇲🇰",
    mask: "0 000 0000",
    placeholder: "0 231 23456"
  },
  {
    name: "Northern Mariana Islands",
    code: "+1",
    flag: "🇲🇵",
    mask: "(670) 000-0000",
    placeholder: "(670) 234-5678"
  },
  {
    name: "Norway",
    code: "+47",
    flag: "🇳🇴",
    mask: "00 00 00 00",
    placeholder: "23 45 67 89"
  },
  {
    name: "Oman",
    code: "+968",
    flag: "🇴🇲",
    mask: "0000 0000",
    placeholder: "9212 3456"
  },
  {
    name: "Pakistan",
    code: "+92",
    flag: "🇵🇰",
    mask: "0000 0000000",
    placeholder: "0301 2345678"
  },
  {
    name: "Palau",
    code: "+680",
    flag: "🇵🇼",
    mask: "000 0000",
    placeholder: "620 1234"
  },
  {
    name: "Palestine",
    code: "+970",
    flag: "🇵🇸",
    mask: "0000 000 000",
    placeholder: "0599 123 456"
  },
  {
    name: "Panama",
    code: "+507",
    flag: "🇵🇦",
    mask: "000-0000",
    placeholder: "6001-2345"
  },
  {
    name: "Papua New Guinea",
    code: "+675",
    flag: "🇵🇬",
    mask: "000 0000",
    placeholder: "7123 4567"
  },
  {
    name: "Paraguay",
    code: "+595",
    flag: "🇵🇾",
    mask: "0000 000 000",
    placeholder: "0981 123 456"
  },
  {
    name: "Peru",
    code: "+51",
    flag: "🇵🇪",
    mask: "(000) 000-000",
    placeholder: "(01) 234-5678"
  },
  {
    name: "Philippines",
    code: "+63",
    flag: "🇵🇭",
    mask: "(000) 000-0000",
    placeholder: "(02) 123-4567"
  },
  {
    name: "Poland",
    code: "+48",
    flag: "🇵🇱",
    mask: "000-000-000",
    placeholder: "123-456-789"
  },
  {
    name: "Portugal",
    code: "+351",
    flag: "🇵🇹",
    mask: "000 000 000",
    placeholder: "123 456 789"
  },
  {
    name: "Qatar",
    code: "+974",
    flag: "🇶🇦",
    mask: "0000 0000",
    placeholder: "1234 5678"
  },
  {
    name: "Romania",
    code: "+40",
    flag: "🇷🇴",
    mask: "0000 000 000",
    placeholder: "021 123 4567"
  },
  {
    name: "Russia",
    code: "+7",
    flag: "🇷🇺",
    mask: "(000) 000-00-00",
    placeholder: "(495) 123-45-67"
  },
  {
    name: "Rwanda",
    code: "+250",
    flag: "🇷🇼",
    mask: "0000 000 000",
    placeholder: "0788 123 456"
  },
  {
    name: "Saint Kitts and Nevis",
    code: "+1-869",
    flag: "🇰🇳",
    mask: "(000) 000-0000",
    placeholder: "(869) 555-1234"
  },
  {
    name: "Saint Lucia",
    code: "+1-758",
    flag: "🇱🇨",
    mask: "(000) 000-0000",
    placeholder: "(758) 284-5678"
  },
  {
    name: "Saint Vincent and the Grenadines",
    code: "+1-784",
    flag: "🇻🇨",
    mask: "(000) 000-0000",
    placeholder: "(784) 430-1234"
  },
  {
    name: "Samoa",
    code: "+685",
    flag: "🇼🇸",
    mask: "000-0000",
    placeholder: "123-4567"
  },
  {
    name: "San Marino",
    code: "+378",
    flag: "🇸🇲",
    mask: "000 000000",
    placeholder: "0549 123456"
  },
  {
    name: "Sao Tome and Principe",
    code: "+239",
    flag: "🇸🇹",
    mask: "000 0000",
    placeholder: "981 2345"
  },
  {
    name: "Saudi Arabia",
    code: "+966",
    flag: "🇸🇦",
    mask: "0000-000-000",
    placeholder: "1234-567-890"
  },
  {
    name: "Senegal",
    code: "+221",
    flag: "🇸🇳",
    mask: "00 00 000 00 00",
    placeholder: "12 34 56 78 90"
  },
  {
    name: "Serbia",
    code: "+381",
    flag: "🇷🇸",
    mask: "000 0000000",
    placeholder: "012 3456789"
  },
  {
    name: "Seychelles",
    code: "+248",
    flag: "🇸🇨",
    mask: "0 000 000",
    placeholder: "2 345 678"
  },
  {
    name: "Sierra Leone",
    code: "+232",
    flag: "🇸🇱",
    mask: "(000) 000-000",
    placeholder: "(123) 456-789"
  },
  {
    name: "Singapore",
    code: "+65",
    flag: "🇸🇬",
    mask: "0000-0000",
    placeholder: "1234-5678"
  },
  {
    name: "Slovakia",
    code: "+421",
    flag: "🇸🇰",
    mask: "0000 000 000",
    placeholder: "1234 567 890"
  },
  {
    name: "Slovenia",
    code: "+386",
    flag: "🇸🇮",
    mask: "00 000 000",
    placeholder: "01 234 567"
  },
  {
    name: "Solomon Islands",
    code: "+677",
    flag: "🇸🇧",
    mask: "0 00000",
    placeholder: "2 34567"
  },
  {
    name: "Somalia",
    code: "+252",
    flag: "🇸🇴",
    mask: "0 0 000000",
    placeholder: "2 3 456789"
  },
  {
    name: "South Africa",
    code: "+27",
    flag: "🇿🇦",
    mask: "(000) 000-0000",
    placeholder: "(123) 456-7890"
  },
  {
    name: "South Korea",
    code: "+82",
    flag: "🇰🇷",
    mask: "000-0000-0000",
    placeholder: "010-1234-5678"
  },
  {
    name: "South Sudan",
    code: "+211",
    flag: "🇸🇸",
    mask: "0000 000 000",
    placeholder: "0123 456 789"
  },
  {
    name: "Spain",
    code: "+34",
    flag: "🇪🇸",
    mask: "000 00 00 00",
    placeholder: "123 45 67 89"
  },
  {
    name: "Sri Lanka",
    code: "+94",
    flag: "🇱🇰",
    mask: "000 000 0000",
    placeholder: "123 456 7890"
  },
  {
    name: "Sudan",
    code: "+249",
    flag: "🇸🇩",
    mask: "00 000 0000",
    placeholder: "12 345 6789"
  },
  {
    name: "Suriname",
    code: "+597",
    flag: "🇸🇷",
    mask: "000-0000",
    placeholder: "123-456"
  },
  {
    name: "Swaziland",
    code: "+268",
    flag: "🇸🇿",
    mask: "00 000 0000",
    placeholder: "76 123 4567"
  },
  {
    name: "Sweden",
    code: "+46",
    flag: "🇸🇪",
    mask: "00 000 00 00",
    placeholder: "08 123 456 78"
  },
  {
    name: "Switzerland",
    code: "+41",
    flag: "🇨🇭",
    mask: "00 000 00 00",
    placeholder: "078 123 45 67"
  },
  {
    name: "Syria",
    code: "+963",
    flag: "🇸🇾",
    mask: "00 000 0000",
    placeholder: "94 456 7890"
  },
  {
    name: "Taiwan",
    code: "+886",
    flag: "🇹🇼",
    mask: "00-0000-0000",
    placeholder: "02-1234-5678"
  },
  {
    name: "Tajikistan",
    code: "+992",
    flag: "🇹🇯",
    mask: "000 000 000",
    placeholder: "93 123 45 67"
  },
  {
    name: "Tanzania",
    code: "+255",
    flag: "🇹🇿",
    mask: "000 000 0000",
    placeholder: "0621 234 567"
  },
  {
    name: "Thailand",
    code: "+66",
    flag: "🇹🇭",
    mask: "00 000 0000",
    placeholder: "08 1234 5678"
  },
  {
    name: "Timor-Leste",
    code: "+670",
    flag: "🇹🇱",
    mask: "000 000 00",
    placeholder: "7721 2345"
  },
  {
    name: "Togo",
    code: "+228",
    flag: "🇹🇬",
    mask: "00 00 00 00",
    placeholder: "90 12 34 56"
  },
  {
    name: "Tonga",
    code: "+676",
    flag: "🇹🇴",
    mask: "0000",
    placeholder: "1234"
  },
  {
    name: "Trinidad and Tobago",
    code: "+1",
    flag: "🇹🇹",
    mask: "(868) 000-0000",
    placeholder: "(868) 555-1234"
  },
  {
    name: "Tunisia",
    code: "+216",
    flag: "🇹🇳",
    mask: "00-000-000",
    placeholder: "12-345-678"
  },
  {
    name: "Turkey",
    code: "+90",
    flag: "🇹🇷",
    mask: "(000) 000-0000",
    placeholder: "(555) 555-1234"
  },
  {
    name: "Turkmenistan",
    code: "+993",
    flag: "🇹🇲",
    mask: "00-000-000",
    placeholder: "12-345-678"
  },
  {
    name: "Tuvalu",
    code: "+688",
    flag: "🇹🇻",
    mask: "000-0000",
    placeholder: "123-4567"
  },
  {
    name: "Uganda",
    code: "+256",
    flag: "🇺🇬",
    mask: "000-000-000",
    placeholder: "123-456-789"
  },
  {
    name: "Ukraine",
    code: "+380",
    flag: "🇺🇦",
    mask: "(000) 000-0000",
    placeholder: "(555) 555-1234"
  },
  {
    name: "United Arab Emirates",
    code: "+971",
    flag: "🇦🇪",
    mask: "000-000-0000",
    placeholder: "123-456-7890"
  },
  {
    name: "United Kingdom",
    code: "+44",
    flag: "🇬🇧",
    mask: "0000-000000",
    placeholder: "1234-567890"
  },
  {
    name: "United States",
    code: "+1",
    flag: "🇺🇸",
    mask: "(000) 000-0000",
    placeholder: "(555) 555-1234"
  },
  {
    name: "Uruguay",
    code: "+598",
    flag: "🇺🇾",
    mask: "0 000 0000",
    placeholder: "9 123 4567"
  },
  {
    name: "Uzbekistan",
    code: "+998",
    flag: "🇺🇿",
    mask: "00-000-00-00",
    placeholder: "12-345-67-89"
  },
  {
    name: "Vanuatu",
    code: "+678",
    flag: "🇻🇺",
    mask: "000-0000",
    placeholder: "123-4567"
  },
  {
    name: "Venezuela",
    code: "+58",
    flag: "🇻🇪",
    mask: "0000-0000000",
    placeholder: "0412-1234567"
  },
  {
    name: "Vietnam",
    code: "+84",
    flag: "🇻🇳",
    mask: "000-000-0000",
    placeholder: "012-345-6789"
  },
  {
    name: "Yemen",
    code: "+967",
    flag: "🇾🇪",
    mask: "0000-000-000",
    placeholder: "0123-456-789"
  },
  {
    name: "Zambia",
    code: "+260",
    flag: "🇿🇲",
    mask: "000-000-0000",
    placeholder: "095-123-4567"
  },
  {
    name: "Zimbabwe",
    code: "+263",
    flag: "🇿🇼",
    mask: "(0) 000 000 0000",
    placeholder: "(0) 123 456 7890"
  },
];

    var mask;
    var $select;
    // Get the country selector and search input elements from the HTML code
    const countrySelector = document.getElementById("country");

    // Populate the country selector with the list of countries
    countries.forEach(country => {
      const option = document.createElement("option");
      option.text = `${country.flag} ${country.name}`;
      option.value = country.name;
      countrySelector.appendChild(option);
    });

    // Add an event listener to the country selector to update the phone number input placeholder and value
    const phoneNumberInput = document.getElementById("id-b3154ecf");
    const button = document.getElementById("id-95a9c13a");
    button.disabled = true;
    phoneNumberInput.addEventListener("input", () => {
      const selectedCountry = countries.find(country => country.name === countrySelector.value);
      const phoneRegex = new RegExp(`^\\+${selectedCountry.code}\\d{3,14}$`);
      const valid = phoneRegex.test(phoneNumberInput.value.replace(/-|\(|\)|\s/g, ''));
      if (valid) {
        phoneNumberInput.setCustomValidity("");
        button.disabled = false;
      } else {
        phoneNumberInput.setCustomValidity(`Please enter a valid phone number in ${selectedCountry.name} format`);
        button.disabled = true;
      }
    });
    const handleCountryChange = (value) => {
      const selectedCountry = countries.find(country => country.name === value);
      const phoneCode = selectedCountry.code;
      phoneNumberInput.placeholder = `${selectedCountry.placeholder}`;
      var maskOptions = { mask: `${selectedCountry.code} ${selectedCountry.mask}` };
      mask.updateOptions(maskOptions);
      mask.value = selectedCountry.code;
    };

    // Set the default country to the first country in the list
    countrySelector.selectedIndex = 0;
    phoneNumberInput.placeholder = countries[0].placeholder;

    var maskOptions = { mask: `${countries[0].code} ${countries[0].mask}` };
    mask = IMask(phoneNumberInput, maskOptions);
    mask.value = countries[0].code;

    $(document).ready(function () {
      $select = $('#country').selectize({
        sortField: 'text',
        onChange: (value) => handleCountryChange(value),
      });
    });

    const xhr = new XMLHttpRequest();
    xhr.open("GET", "http://geoplugin.net/json.gp", true);
    xhr.responseType = "json";

    xhr.onload = function () {
    //   const countryName = xhr?.response?.geoplugin_countryName;
    //   const country = countries.find(c => c.name === countryName);
    //   if (country) {
    //     if ($select) {
    //       var selectize = $select[0].selectize;
    //       selectize.setValue(country.name);
    //     } else {
    //       $('#country').val(country.name);
    //     }
    //     var maskOptions = { mask: `${country.code} ${country.mask}` };
    //     mask.updateOptions(maskOptions);
    //     mask.value = country.code;
    //   }
    };

    xhr.send();

    mask.on('accept', (e) => {
      const val = mask.value.replace(/-|\(|\)|\s/g, '');
      const fullPhone = document.getElementById("id-610de994");
      if(fullPhone)
        fullPhone.value = val;
    })
});